<template>
  <div v-if="validation.$error">
    <p v-for="error of validation.$errors" :key="error.$uid" class="mt-3 mb-8 text-red">
      {{ error.$message }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { BaseValidation } from '@vuelidate/core'

defineProps<{
  validation: BaseValidation
}>()
</script>
